interface LazyRetryConfig {
    retriesLeft?: number;
    interval?: number;
}

function lazyRetry<T>(
    fn: () => Promise<T>,
    onError: () => void = () => window.location.reload(),
    config?: LazyRetryConfig,
): Promise<T> {
    const retriesLeft = config?.retriesLeft || 5;
    const interval = config?.interval || 1000;

    return new Promise((resolve, reject) => {
        fn()
            .then(resolve)
            .catch((error) => {
                setTimeout(() => {
                    if (retriesLeft === 1) {
                        onError();
                        reject(error);
                        return;
                    }

                    lazyRetry(fn, onError, {retriesLeft: retriesLeft - 1, interval}).then(resolve, reject);
                }, interval);
            });
    });
}

export {lazyRetry};
